import { NOVICE, INTERMEDIATE, EXPERT } from '../Constants/SkillLevel';
import { Pause } from '../GameFunctions/MiscGameFunctions';
import ComputerMoveNovice from "../GameFunctions/ComputerMoveNovice";
import ComputerMoveExpert from "../GameFunctions/ComputerMoveExpert";
import ComputerMoveMedium from "../GameFunctions/ComputerMoveMedium";

function DetermineComputerMove(squares, expertMode) {
    Pause();
    let computerMove;
    switch(expertMode) {
        case NOVICE:
            computerMove = ComputerMoveNovice(squares)
            break;
        case INTERMEDIATE:
            computerMove = ComputerMoveMedium(squares)
            break;
        case EXPERT:
            computerMove = ComputerMoveExpert(squares).index
            break;
        default:
            computerMove = ComputerMoveNovice(squares)
    }
    return computerMove;
}

export default DetermineComputerMove;


